export function pushToDataLayer(eventData, retryCount = 0) {
    const MAX_RETRIES = 5;

    const formattedEvent = {
        event: 'customGa4Event',
        ...eventData
    };
    
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(formattedEvent);
    } else if (retryCount < MAX_RETRIES) {
        setTimeout(() => pushToDataLayer(eventData, retryCount + 1), 300);
    }
}